import React from 'react';
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Container,
  Flex,
  Heading,
  HStack,
  Icon,
  Text,
  useColorModeValue,
  VStack
} from '@chakra-ui/react';
import { FiShield } from 'react-icons/fi';
import ColorModeToggle from '../components/color-mode-toggle';
import PrivacyPolicyContent from '../components/privacy-policy-content';

function PrivacyPolicy(): JSX.Element {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('green.100', 'gray.700');
  const headerBg = useColorModeValue('green.500', 'green.600');
  const bgGradientOverlay = useColorModeValue(
    'linear(135deg, rgba(247, 250, 252, 0.85) 0%, rgba(240, 253, 244, 0.85) 100%)',
    'linear(135deg, rgba(26, 32, 44, 0.85) 0%, rgba(45, 55, 72, 0.85) 100%)'
  );

  return (
    <Box
      minH="100vh"
      position="relative"
      py={8}
      className="fade-in-up"
      backgroundImage="url('/pacifico-sede.gif')"
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundAttachment={{ base: 'scroll', md: 'fixed' }}
      _before={{
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgGradient: bgGradientOverlay,
        zIndex: 1
      }}
    >
      <Container
        maxW={{ base: 'lg', md: '3xl', lg: '5xl' }}
        centerContent
        position="relative"
        zIndex={2}
        width="100%"
      >
        <Flex direction="column" align="center" w="full" mb={8}>
          <HStack justify="space-between" w="full" mb={4}>
            <Box />
            <ColorModeToggle />
          </HStack>

          <Card
            w="full"
            maxW={{ base: 'md', md: '2xl', lg: '4xl' }}
            shadow="2xl"
            bg={cardBg}
            borderRadius="2xl"
            border="1px"
            borderColor={borderColor}
            className="card-hover"
            overflow="hidden"
          >
            <CardHeader bg={headerBg} color="white" textAlign="center" py={6}>
              <VStack spacing={2}>
                <Icon as={FiShield} boxSize={8} />
                <Heading size="lg" fontWeight="bold">
                  Política de Privacidad
                </Heading>
                <Text fontSize="sm" opacity={0.9}>
                  Aplicación de comunicaciones por WhatsApp — Club Atlético Pacífico
                </Text>
                <Text fontSize="xs" opacity={0.85}>
                  Última actualización: 17 de octubre de 2026
                </Text>
              </VStack>
            </CardHeader>

            <CardBody p={{ base: 5, md: 8 }}>
              <PrivacyPolicyContent />
            </CardBody>
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}

export default PrivacyPolicy;
